import { LoadingOutlined } from '@ant-design/icons'
import { Spin } from 'antd'
import PropTypes from 'prop-types'
import EllipsisTooltip from './EllipsisTooltip'

const ProgresSpinner = (props) => {
  const { caption, className, size = 'default', fullscreen = false } = props

  return (
    <div className={`progress-wrapper ${className}`}>
      <Spin indicator={<LoadingOutlined spin />} size={size} />
      <span className="content">
        {<EllipsisTooltip className='ellipsis'>{caption}</EllipsisTooltip>}
      </span>
    </div>
  )
}

ProgresSpinner.propTypes = {
  caption: PropTypes.string.isRequired,
  className: PropTypes.string,
  size: PropTypes.string,
}

export { ProgresSpinner }
